import { useStorage } from '@vueuse/core';

export const useChatVersion = () =>
  useStorage<'alpha' | 'beta' | 'stable'>('chat.version', 'stable');
